import React from "react";
import styled from "styled-components";
import { HashLink } from "react-router-hash-link";
import { useState } from "react";
import { useEffect } from "react";

const List = styled.div`
  display: none;
  cursor: pointer;
  @media (max-width: 1200px) {
    display: flex;
    justify-content: space-between;
    border: 1px solid #e0e0e0;
    padding: 10px;
    border-radius: 5px;
  }
`;

const Container = styled.div`
  width: 100%;
  border: 1px solid #e0e0e0;
  padding: 10px;
  border-radius: 5px;
  display: ${({ isOpen }) => (isOpen ? "block" : "none")};
  .information {
    display: flex;
    align-items: center;
    padding: 5px;
    cursor: pointer;
    .icon_box {
      width: 30px;
      padding: 5px;
      .icon {
        color: #057aff;
      }
    }
    .name {
      width: 100px;
      display: flex;
      justify-content: flex-start;
      font-size: 14px;
      text-decoration: none;
    }
  }
  .message {
    display: flex;
    align-items: center;
    padding: 5px;
    cursor: pointer;
    .icon_box {
      width: 30px;
      padding: 5px;
      .icon {
        color: #057aff;
      }
    }
    .name {
      width: 100px;
      display: flex;
      justify-content: flex-start;
      font-size: 14px;
    }
  }
  .reply {
    display: flex;
    align-items: center;
    padding: 5px;
    cursor: pointer;
    .icon_box {
      width: 30px;
      padding: 5px;
      .icon {
        color: #057aff;
      }
    }
    .name {
      width: 100px;
      display: flex;
      justify-content: flex-start;
      font-size: 14px;
    }
  }
  .giveBack {
    display: flex;
    align-items: center;
    padding: 5px;
    cursor: pointer;
    .icon_box {
      width: 30px;
      padding: 5px;
      .icon {
        color: #057aff;
      }
    }
    .name {
      width: 100px;
      display: flex;
      justify-content: flex-start;
      font-size: 14px;
    }
  }
`;

function EditBodyHashLink({ rowId }) {
  const [open, setOpen] = useState(true);
  function handleOpen() {
    if (window.innerWidth <= 1200) {
      setOpen(!open)
    }else{
      setOpen(true)
    }
  }

  useEffect(() => {
    window.addEventListener("resize", handleOpen);
    return () => {
      window.addEventListener("resize", handleOpen);
    };
  }, []);
  return (
    <>
      <List onClick={handleOpen}>
        <div>選單</div>
        <i className="fa-solid fa-bars" ></i>
      </List>
      <Container isOpen={open}>
        <div className="information">
          <div className="icon_box">
            <i className="fa-solid fa-rectangle-list icon"></i>
          </div>
          <HashLink
            scroll={(e) => e.scrollIntoView({ behavior: "smooth" })}
            to={`/ReferralEditData?rowId=${rowId}#one`}
            className="name"
          >
            轉介個案資訊
          </HashLink>
        </div>
        <div className="message">
          <div className="icon_box">
            <i className="fa-solid fa-comment-medical icon"></i>
          </div>
          <HashLink
            scroll={(e) => e.scrollIntoView({ behavior: "smooth" })}
            to={`/ReferralEditData?rowId=${rowId}#two`}
            className="name"
          >
            病情留言板
          </HashLink>
        </div>
        <div className="reply">
          <div className="icon_box">
            <i className="fa-solid fa-comment-medical icon"></i>
          </div>
          <HashLink
            scroll={(e) => e.scrollIntoView({ behavior: "smooth" })}
            to={`/ReferralEditData?rowId=${rowId}#three`}
            className="name"
          >
            術後病情回覆
          </HashLink>
        </div>
        <div className="giveBack">
          <div className="icon_box">
            <i className="fa-solid fa-notes-medical icon"></i>
          </div>
          <HashLink
            scroll={(e) => e.scrollIntoView({ behavior: "smooth" })}
            to={`/ReferralEditData?rowId=${rowId}#four`}
            className="name"
          >
            轉診回饋單
          </HashLink>
        </div>
      </Container>
    </>
  );
}

export default EditBodyHashLink;
